<div class="main-content">
    <nz-card [nzTitle]="showHeader ? cardHeader : null">
        <ng-template #cardHeader>
            <div class="card-header-title">
                <generic-icon [iconName]="icon" type="google"></generic-icon>
                <span>{{title}}</span>
            </div>
        </ng-template>

        <div class="content">
            <form [formGroup]="formGroup">
                <div *ngFor="let param of parameters" class="fields">
                <ng-container  #viewContainer2 dynamicField  [config]="param" [group]="formGroup"  [arrayColumnsDef]="parameters" [isDynamicform]="false" class="full" [entityName]="entityName" >
                </ng-container>

                </div>
            </form>
        </div>

        <div class="buttons">
            <button nz-button nzType="primary" (click)="ok()">Confirmar</button>
            <button nz-button nzType="primary" nzDanger (click)="cancelar()">Cancelar</button>
        </div>
    </nz-card>
</div>
